/** Houston ad landing vehicles, seeded from U.S. / Houston best-seller volume. */
export type HoustonCarLanding = {
  make: string;
  model: string;
  makeSlug: string;
  modelSlug: string;
  displayName: string;
  vehicleClass: string;
};

export const HOUSTON_CAR_LANDINGS: HoustonCarLanding[] = [
  {
    make: 'Toyota',
    model: 'Camry',
    makeSlug: 'toyota',
    modelSlug: 'camry',
    displayName: 'Toyota Camry',
    vehicleClass: 'midsize sedan',
  },
  {
    make: 'Toyota',
    model: 'RAV4',
    makeSlug: 'toyota',
    modelSlug: 'rav4',
    displayName: 'Toyota RAV4',
    vehicleClass: 'compact SUV',
  },
  {
    make: 'Toyota',
    model: 'Tacoma',
    makeSlug: 'toyota',
    modelSlug: 'tacoma',
    displayName: 'Toyota Tacoma',
    vehicleClass: 'midsize truck',
  },
  {
    make: 'Ford',
    model: 'F-150',
    makeSlug: 'ford',
    modelSlug: 'f-150',
    displayName: 'Ford F-150',
    vehicleClass: 'full-size truck',
  },
  {
    make: 'Honda',
    model: 'CR-V',
    makeSlug: 'honda',
    modelSlug: 'cr-v',
    displayName: 'Honda CR-V',
    vehicleClass: 'compact SUV',
  },
  {
    make: 'Toyota',
    model: 'Tundra',
    makeSlug: 'toyota',
    modelSlug: 'tundra',
    displayName: 'Toyota Tundra',
    vehicleClass: 'full-size truck',
  },
  {
    make: 'Toyota',
    model: 'Corolla',
    makeSlug: 'toyota',
    modelSlug: 'corolla',
    displayName: 'Toyota Corolla',
    vehicleClass: 'compact sedan',
  },
  {
    make: 'Chevrolet',
    model: 'Silverado 1500',
    makeSlug: 'chevrolet',
    modelSlug: 'silverado-1500',
    displayName: 'Chevrolet Silverado 1500',
    vehicleClass: 'full-size truck',
  },
  {
    make: 'GMC',
    model: 'Sierra 1500',
    makeSlug: 'gmc',
    modelSlug: 'sierra-1500',
    displayName: 'GMC Sierra 1500',
    vehicleClass: 'full-size truck',
  },
  {
    make: 'Toyota',
    model: 'Grand Highlander',
    makeSlug: 'toyota',
    modelSlug: 'grand-highlander',
    displayName: 'Toyota Grand Highlander',
    vehicleClass: '3-row SUV',
  },
  // Next 10 by U.S. sales volume (2025), excluding the set above
  {
    make: 'Ram',
    model: '1500',
    makeSlug: 'ram',
    modelSlug: '1500',
    displayName: 'Ram 1500',
    vehicleClass: 'full-size truck',
  },
  {
    make: 'Chevrolet',
    model: 'Equinox',
    makeSlug: 'chevrolet',
    modelSlug: 'equinox',
    displayName: 'Chevrolet Equinox',
    vehicleClass: 'compact SUV',
  },
  {
    make: 'Tesla',
    model: 'Model Y',
    makeSlug: 'tesla',
    modelSlug: 'model-y',
    displayName: 'Tesla Model Y',
    vehicleClass: 'electric SUV',
  },
  {
    make: 'Honda',
    model: 'Civic',
    makeSlug: 'honda',
    modelSlug: 'civic',
    displayName: 'Honda Civic',
    vehicleClass: 'compact sedan',
  },
  {
    make: 'Hyundai',
    model: 'Tucson',
    makeSlug: 'hyundai',
    modelSlug: 'tucson',
    displayName: 'Hyundai Tucson',
    vehicleClass: 'compact SUV',
  },
  {
    make: 'Ford',
    model: 'Explorer',
    makeSlug: 'ford',
    modelSlug: 'explorer',
    displayName: 'Ford Explorer',
    vehicleClass: '3-row SUV',
  },
  {
    make: 'Nissan',
    model: 'Rogue',
    makeSlug: 'nissan',
    modelSlug: 'rogue',
    displayName: 'Nissan Rogue',
    vehicleClass: 'compact SUV',
  },
  {
    make: 'Jeep',
    model: 'Grand Cherokee',
    makeSlug: 'jeep',
    modelSlug: 'grand-cherokee',
    displayName: 'Jeep Grand Cherokee',
    vehicleClass: 'midsize SUV',
  },
  {
    make: 'Chevrolet',
    model: 'Trax',
    makeSlug: 'chevrolet',
    modelSlug: 'trax',
    displayName: 'Chevrolet Trax',
    vehicleClass: 'subcompact SUV',
  },
  {
    make: 'Subaru',
    model: 'Crosstrek',
    makeSlug: 'subaru',
    modelSlug: 'crosstrek',
    displayName: 'Subaru Crosstrek',
    vehicleClass: 'compact SUV',
  },
  // Next 10 by U.S. sales volume (2025), skipping Ford Transit (commercial van)
  {
    make: 'Kia',
    model: 'Sportage',
    makeSlug: 'kia',
    modelSlug: 'sportage',
    displayName: 'Kia Sportage',
    vehicleClass: 'compact SUV',
  },
  {
    make: 'Subaru',
    model: 'Forester',
    makeSlug: 'subaru',
    modelSlug: 'forester',
    displayName: 'Subaru Forester',
    vehicleClass: 'compact SUV',
  },
  {
    make: 'Tesla',
    model: 'Model 3',
    makeSlug: 'tesla',
    modelSlug: 'model-3',
    displayName: 'Tesla Model 3',
    vehicleClass: 'electric sedan',
  },
  {
    make: 'Jeep',
    model: 'Wrangler',
    makeSlug: 'jeep',
    modelSlug: 'wrangler',
    displayName: 'Jeep Wrangler',
    vehicleClass: 'midsize SUV',
  },
  {
    make: 'Subaru',
    model: 'Outback',
    makeSlug: 'subaru',
    modelSlug: 'outback',
    displayName: 'Subaru Outback',
    vehicleClass: 'midsize SUV',
  },
  {
    make: 'Ford',
    model: 'Maverick',
    makeSlug: 'ford',
    modelSlug: 'maverick',
    displayName: 'Ford Maverick',
    vehicleClass: 'compact truck',
  },
  {
    make: 'Toyota',
    model: 'Highlander',
    makeSlug: 'toyota',
    modelSlug: 'highlander',
    displayName: 'Toyota Highlander',
    vehicleClass: '3-row SUV',
  },
  {
    make: 'Honda',
    model: 'Accord',
    makeSlug: 'honda',
    modelSlug: 'accord',
    displayName: 'Honda Accord',
    vehicleClass: 'midsize sedan',
  },
  {
    make: 'Toyota',
    model: '4Runner',
    makeSlug: 'toyota',
    modelSlug: '4runner',
    displayName: 'Toyota 4Runner',
    vehicleClass: 'midsize SUV',
  },
  {
    make: 'Honda',
    model: 'Pilot',
    makeSlug: 'honda',
    modelSlug: 'pilot',
    displayName: 'Honda Pilot',
    vehicleClass: '3-row SUV',
  },
  // Remaining of the 50-vehicle expansion (40 more high-volume U.S. models)
  {
    make: 'Ford',
    model: 'Escape',
    makeSlug: 'ford',
    modelSlug: 'escape',
    displayName: 'Ford Escape',
    vehicleClass: 'compact SUV',
  },
  {
    make: 'Kia',
    model: 'Telluride',
    makeSlug: 'kia',
    modelSlug: 'telluride',
    displayName: 'Kia Telluride',
    vehicleClass: '3-row SUV',
  },
  {
    make: 'Hyundai',
    model: 'Santa Fe',
    makeSlug: 'hyundai',
    modelSlug: 'santa-fe',
    displayName: 'Hyundai Santa Fe',
    vehicleClass: 'midsize SUV',
  },
  {
    make: 'Mazda',
    model: 'CX-5',
    makeSlug: 'mazda',
    modelSlug: 'cx-5',
    displayName: 'Mazda CX-5',
    vehicleClass: 'compact SUV',
  },
  {
    make: 'Honda',
    model: 'HR-V',
    makeSlug: 'honda',
    modelSlug: 'hr-v',
    displayName: 'Honda HR-V',
    vehicleClass: 'subcompact SUV',
  },
  {
    make: 'Chevrolet',
    model: 'Colorado',
    makeSlug: 'chevrolet',
    modelSlug: 'colorado',
    displayName: 'Chevrolet Colorado',
    vehicleClass: 'midsize truck',
  },
  {
    make: 'Toyota',
    model: 'Sienna',
    makeSlug: 'toyota',
    modelSlug: 'sienna',
    displayName: 'Toyota Sienna',
    vehicleClass: 'minivan',
  },
  {
    make: 'Honda',
    model: 'Odyssey',
    makeSlug: 'honda',
    modelSlug: 'odyssey',
    displayName: 'Honda Odyssey',
    vehicleClass: 'minivan',
  },
  {
    make: 'Ford',
    model: 'Bronco',
    makeSlug: 'ford',
    modelSlug: 'bronco',
    displayName: 'Ford Bronco',
    vehicleClass: 'midsize SUV',
  },
  {
    make: 'Ford',
    model: 'Bronco Sport',
    makeSlug: 'ford',
    modelSlug: 'bronco-sport',
    displayName: 'Ford Bronco Sport',
    vehicleClass: 'compact SUV',
  },
  {
    make: 'Jeep',
    model: 'Compass',
    makeSlug: 'jeep',
    modelSlug: 'compass',
    displayName: 'Jeep Compass',
    vehicleClass: 'compact SUV',
  },
  {
    make: 'Hyundai',
    model: 'Elantra',
    makeSlug: 'hyundai',
    modelSlug: 'elantra',
    displayName: 'Hyundai Elantra',
    vehicleClass: 'compact sedan',
  },
  {
    make: 'Kia',
    model: 'Sorento',
    makeSlug: 'kia',
    modelSlug: 'sorento',
    displayName: 'Kia Sorento',
    vehicleClass: '3-row SUV',
  },
  {
    make: 'Hyundai',
    model: 'Palisade',
    makeSlug: 'hyundai',
    modelSlug: 'palisade',
    displayName: 'Hyundai Palisade',
    vehicleClass: '3-row SUV',
  },
  {
    make: 'Chevrolet',
    model: 'Traverse',
    makeSlug: 'chevrolet',
    modelSlug: 'traverse',
    displayName: 'Chevrolet Traverse',
    vehicleClass: '3-row SUV',
  },
  {
    make: 'Nissan',
    model: 'Pathfinder',
    makeSlug: 'nissan',
    modelSlug: 'pathfinder',
    displayName: 'Nissan Pathfinder',
    vehicleClass: '3-row SUV',
  },
  {
    make: 'GMC',
    model: 'Acadia',
    makeSlug: 'gmc',
    modelSlug: 'acadia',
    displayName: 'GMC Acadia',
    vehicleClass: 'midsize SUV',
  },
  {
    make: 'Ford',
    model: 'Ranger',
    makeSlug: 'ford',
    modelSlug: 'ranger',
    displayName: 'Ford Ranger',
    vehicleClass: 'midsize truck',
  },
  {
    make: 'Nissan',
    model: 'Frontier',
    makeSlug: 'nissan',
    modelSlug: 'frontier',
    displayName: 'Nissan Frontier',
    vehicleClass: 'midsize truck',
  },
  {
    make: 'Toyota',
    model: 'Sequoia',
    makeSlug: 'toyota',
    modelSlug: 'sequoia',
    displayName: 'Toyota Sequoia',
    vehicleClass: 'full-size SUV',
  },
  {
    make: 'Ford',
    model: 'Expedition',
    makeSlug: 'ford',
    modelSlug: 'expedition',
    displayName: 'Ford Expedition',
    vehicleClass: 'full-size SUV',
  },
  {
    make: 'Chevrolet',
    model: 'Tahoe',
    makeSlug: 'chevrolet',
    modelSlug: 'tahoe',
    displayName: 'Chevrolet Tahoe',
    vehicleClass: 'full-size SUV',
  },
  {
    make: 'Chevrolet',
    model: 'Suburban',
    makeSlug: 'chevrolet',
    modelSlug: 'suburban',
    displayName: 'Chevrolet Suburban',
    vehicleClass: 'full-size SUV',
  },
  {
    make: 'GMC',
    model: 'Yukon',
    makeSlug: 'gmc',
    modelSlug: 'yukon',
    displayName: 'GMC Yukon',
    vehicleClass: 'full-size SUV',
  },
  {
    make: 'Volkswagen',
    model: 'Tiguan',
    makeSlug: 'volkswagen',
    modelSlug: 'tiguan',
    displayName: 'Volkswagen Tiguan',
    vehicleClass: 'compact SUV',
  },
  {
    make: 'Mazda',
    model: 'CX-50',
    makeSlug: 'mazda',
    modelSlug: 'cx-50',
    displayName: 'Mazda CX-50',
    vehicleClass: 'compact SUV',
  },
  {
    make: 'Honda',
    model: 'Passport',
    makeSlug: 'honda',
    modelSlug: 'passport',
    displayName: 'Honda Passport',
    vehicleClass: 'midsize SUV',
  },
  {
    make: 'Kia',
    model: 'Carnival',
    makeSlug: 'kia',
    modelSlug: 'carnival',
    displayName: 'Kia Carnival',
    vehicleClass: 'minivan',
  },
  {
    make: 'Chrysler',
    model: 'Pacifica',
    makeSlug: 'chrysler',
    modelSlug: 'pacifica',
    displayName: 'Chrysler Pacifica',
    vehicleClass: 'minivan',
  },
  {
    make: 'Dodge',
    model: 'Durango',
    makeSlug: 'dodge',
    modelSlug: 'durango',
    displayName: 'Dodge Durango',
    vehicleClass: '3-row SUV',
  },
  {
    make: 'Jeep',
    model: 'Gladiator',
    makeSlug: 'jeep',
    modelSlug: 'gladiator',
    displayName: 'Jeep Gladiator',
    vehicleClass: 'midsize truck',
  },
  {
    make: 'Toyota',
    model: 'Prius',
    makeSlug: 'toyota',
    modelSlug: 'prius',
    displayName: 'Toyota Prius',
    vehicleClass: 'hybrid sedan',
  },
  {
    make: 'Nissan',
    model: 'Altima',
    makeSlug: 'nissan',
    modelSlug: 'altima',
    displayName: 'Nissan Altima',
    vehicleClass: 'midsize sedan',
  },
  {
    make: 'Hyundai',
    model: 'Sonata',
    makeSlug: 'hyundai',
    modelSlug: 'sonata',
    displayName: 'Hyundai Sonata',
    vehicleClass: 'midsize sedan',
  },
  {
    make: 'Chevrolet',
    model: 'Blazer',
    makeSlug: 'chevrolet',
    modelSlug: 'blazer',
    displayName: 'Chevrolet Blazer',
    vehicleClass: 'midsize SUV',
  },
  {
    make: 'GMC',
    model: 'Canyon',
    makeSlug: 'gmc',
    modelSlug: 'canyon',
    displayName: 'GMC Canyon',
    vehicleClass: 'midsize truck',
  },
  {
    make: 'Ford',
    model: 'Mustang',
    makeSlug: 'ford',
    modelSlug: 'mustang',
    displayName: 'Ford Mustang',
    vehicleClass: 'sports car',
  },
  {
    make: 'Volkswagen',
    model: 'Atlas',
    makeSlug: 'volkswagen',
    modelSlug: 'atlas',
    displayName: 'Volkswagen Atlas',
    vehicleClass: '3-row SUV',
  },
  {
    make: 'Buick',
    model: 'Enclave',
    makeSlug: 'buick',
    modelSlug: 'enclave',
    displayName: 'Buick Enclave',
    vehicleClass: '3-row SUV',
  },
  {
    make: 'Lexus',
    model: 'RX',
    makeSlug: 'lexus',
    modelSlug: 'rx',
    displayName: 'Lexus RX',
    vehicleClass: 'luxury SUV',
  },
  // Next 40 unique high-volume / high-intent models
  {
    make: 'Toyota',
    model: 'Corolla Cross',
    makeSlug: 'toyota',
    modelSlug: 'corolla-cross',
    displayName: 'Toyota Corolla Cross',
    vehicleClass: 'compact SUV',
  },
  {
    make: 'Honda',
    model: 'Ridgeline',
    makeSlug: 'honda',
    modelSlug: 'ridgeline',
    displayName: 'Honda Ridgeline',
    vehicleClass: 'midsize truck',
  },
  {
    make: 'Chevrolet',
    model: 'Trailblazer',
    makeSlug: 'chevrolet',
    modelSlug: 'trailblazer',
    displayName: 'Chevrolet Trailblazer',
    vehicleClass: 'subcompact SUV',
  },
  {
    make: 'GMC',
    model: 'Terrain',
    makeSlug: 'gmc',
    modelSlug: 'terrain',
    displayName: 'GMC Terrain',
    vehicleClass: 'compact SUV',
  },
  {
    make: 'Kia',
    model: 'Soul',
    makeSlug: 'kia',
    modelSlug: 'soul',
    displayName: 'Kia Soul',
    vehicleClass: 'subcompact SUV',
  },
  {
    make: 'Kia',
    model: 'Forte',
    makeSlug: 'kia',
    modelSlug: 'forte',
    displayName: 'Kia Forte',
    vehicleClass: 'compact sedan',
  },
  {
    make: 'Hyundai',
    model: 'Kona',
    makeSlug: 'hyundai',
    modelSlug: 'kona',
    displayName: 'Hyundai Kona',
    vehicleClass: 'subcompact SUV',
  },
  {
    make: 'Nissan',
    model: 'Kicks',
    makeSlug: 'nissan',
    modelSlug: 'kicks',
    displayName: 'Nissan Kicks',
    vehicleClass: 'subcompact SUV',
  },
  {
    make: 'Nissan',
    model: 'Murano',
    makeSlug: 'nissan',
    modelSlug: 'murano',
    displayName: 'Nissan Murano',
    vehicleClass: 'midsize SUV',
  },
  {
    make: 'Nissan',
    model: 'Armada',
    makeSlug: 'nissan',
    modelSlug: 'armada',
    displayName: 'Nissan Armada',
    vehicleClass: 'full-size SUV',
  },
  {
    make: 'Toyota',
    model: 'Venza',
    makeSlug: 'toyota',
    modelSlug: 'venza',
    displayName: 'Toyota Venza',
    vehicleClass: 'midsize SUV',
  },
  {
    make: 'Toyota',
    model: 'Land Cruiser',
    makeSlug: 'toyota',
    modelSlug: 'land-cruiser',
    displayName: 'Toyota Land Cruiser',
    vehicleClass: 'full-size SUV',
  },
  {
    make: 'Ford',
    model: 'Edge',
    makeSlug: 'ford',
    modelSlug: 'edge',
    displayName: 'Ford Edge',
    vehicleClass: 'midsize SUV',
  },
  {
    make: 'Ford',
    model: 'F-250',
    makeSlug: 'ford',
    modelSlug: 'f-250',
    displayName: 'Ford F-250',
    vehicleClass: 'full-size truck',
  },
  {
    make: 'Chevrolet',
    model: 'Malibu',
    makeSlug: 'chevrolet',
    modelSlug: 'malibu',
    displayName: 'Chevrolet Malibu',
    vehicleClass: 'midsize sedan',
  },
  {
    make: 'Jeep',
    model: 'Wagoneer',
    makeSlug: 'jeep',
    modelSlug: 'wagoneer',
    displayName: 'Jeep Wagoneer',
    vehicleClass: 'full-size SUV',
  },
  {
    make: 'Jeep',
    model: 'Cherokee',
    makeSlug: 'jeep',
    modelSlug: 'cherokee',
    displayName: 'Jeep Cherokee',
    vehicleClass: 'compact SUV',
  },
  {
    make: 'Ram',
    model: '2500',
    makeSlug: 'ram',
    modelSlug: '2500',
    displayName: 'Ram 2500',
    vehicleClass: 'full-size truck',
  },
  {
    make: 'Mazda',
    model: 'CX-30',
    makeSlug: 'mazda',
    modelSlug: 'cx-30',
    displayName: 'Mazda CX-30',
    vehicleClass: 'subcompact SUV',
  },
  {
    make: 'Mazda',
    model: 'CX-90',
    makeSlug: 'mazda',
    modelSlug: 'cx-90',
    displayName: 'Mazda CX-90',
    vehicleClass: '3-row SUV',
  },
  {
    make: 'Mazda',
    model: 'Mazda3',
    makeSlug: 'mazda',
    modelSlug: 'mazda3',
    displayName: 'Mazda3',
    vehicleClass: 'compact sedan',
  },
  {
    make: 'Subaru',
    model: 'Ascent',
    makeSlug: 'subaru',
    modelSlug: 'ascent',
    displayName: 'Subaru Ascent',
    vehicleClass: '3-row SUV',
  },
  {
    make: 'Volkswagen',
    model: 'Jetta',
    makeSlug: 'volkswagen',
    modelSlug: 'jetta',
    displayName: 'Volkswagen Jetta',
    vehicleClass: 'compact sedan',
  },
  {
    make: 'Lexus',
    model: 'NX',
    makeSlug: 'lexus',
    modelSlug: 'nx',
    displayName: 'Lexus NX',
    vehicleClass: 'luxury SUV',
  },
  {
    make: 'Lexus',
    model: 'ES',
    makeSlug: 'lexus',
    modelSlug: 'es',
    displayName: 'Lexus ES',
    vehicleClass: 'luxury sedan',
  },
  {
    make: 'Acura',
    model: 'MDX',
    makeSlug: 'acura',
    modelSlug: 'mdx',
    displayName: 'Acura MDX',
    vehicleClass: 'luxury SUV',
  },
  {
    make: 'Acura',
    model: 'RDX',
    makeSlug: 'acura',
    modelSlug: 'rdx',
    displayName: 'Acura RDX',
    vehicleClass: 'luxury SUV',
  },
  {
    make: 'BMW',
    model: 'X3',
    makeSlug: 'bmw',
    modelSlug: 'x3',
    displayName: 'BMW X3',
    vehicleClass: 'luxury SUV',
  },
  {
    make: 'BMW',
    model: 'X5',
    makeSlug: 'bmw',
    modelSlug: 'x5',
    displayName: 'BMW X5',
    vehicleClass: 'luxury SUV',
  },
  {
    make: 'Audi',
    model: 'Q5',
    makeSlug: 'audi',
    modelSlug: 'q5',
    displayName: 'Audi Q5',
    vehicleClass: 'luxury SUV',
  },
  {
    make: 'Mercedes-Benz',
    model: 'GLC',
    makeSlug: 'mercedes-benz',
    modelSlug: 'glc',
    displayName: 'Mercedes-Benz GLC',
    vehicleClass: 'luxury SUV',
  },
  {
    make: 'Cadillac',
    model: 'XT5',
    makeSlug: 'cadillac',
    modelSlug: 'xt5',
    displayName: 'Cadillac XT5',
    vehicleClass: 'luxury SUV',
  },
  {
    make: 'Genesis',
    model: 'GV70',
    makeSlug: 'genesis',
    modelSlug: 'gv70',
    displayName: 'Genesis GV70',
    vehicleClass: 'luxury SUV',
  },
  {
    make: 'Genesis',
    model: 'GV80',
    makeSlug: 'genesis',
    modelSlug: 'gv80',
    displayName: 'Genesis GV80',
    vehicleClass: 'luxury SUV',
  },
  {
    make: 'Hyundai',
    model: 'Ioniq 5',
    makeSlug: 'hyundai',
    modelSlug: 'ioniq-5',
    displayName: 'Hyundai Ioniq 5',
    vehicleClass: 'electric SUV',
  },
  {
    make: 'Kia',
    model: 'EV6',
    makeSlug: 'kia',
    modelSlug: 'ev6',
    displayName: 'Kia EV6',
    vehicleClass: 'electric SUV',
  },
  {
    make: 'Tesla',
    model: 'Cybertruck',
    makeSlug: 'tesla',
    modelSlug: 'cybertruck',
    displayName: 'Tesla Cybertruck',
    vehicleClass: 'electric truck',
  },
  {
    make: 'Mitsubishi',
    model: 'Outlander',
    makeSlug: 'mitsubishi',
    modelSlug: 'outlander',
    displayName: 'Mitsubishi Outlander',
    vehicleClass: '3-row SUV',
  },
  {
    make: 'Buick',
    model: 'Encore GX',
    makeSlug: 'buick',
    modelSlug: 'encore-gx',
    displayName: 'Buick Encore GX',
    vehicleClass: 'subcompact SUV',
  },
  {
    make: 'Volvo',
    model: 'XC60',
    makeSlug: 'volvo',
    modelSlug: 'xc60',
    displayName: 'Volvo XC60',
    vehicleClass: 'luxury SUV',
  },
];

export function findHoustonCarLanding(
  makeSlug: string | undefined,
  modelSlug: string | undefined
): HoustonCarLanding | undefined {
  if (!makeSlug || !modelSlug) return undefined;
  const make = makeSlug.toLowerCase();
  const model = modelSlug.toLowerCase();
  return HOUSTON_CAR_LANDINGS.find((car) => car.makeSlug === make && car.modelSlug === model);
}

export function houstonCarPath(car: HoustonCarLanding): string {
  return `/car-insurance/houston/${car.makeSlug}/${car.modelSlug}`;
}

export function houstonCarQuotePath(car: HoustonCarLanding): string {
  const params = new URLSearchParams({
    type: 'car',
    make: car.makeSlug,
    model: car.modelSlug,
  });
  return `/get-quote?${params.toString()}`;
}

/** Next N landings after `car` in the list (wraps), excluding the current vehicle. */
export function relatedHoustonCarLandings(
  car: HoustonCarLanding,
  limit = 8
): HoustonCarLanding[] {
  const idx = HOUSTON_CAR_LANDINGS.findIndex(
    (entry) => entry.makeSlug === car.makeSlug && entry.modelSlug === car.modelSlug
  );
  if (idx < 0 || HOUSTON_CAR_LANDINGS.length <= 1) return [];

  const related: HoustonCarLanding[] = [];
  for (let step = 1; step < HOUSTON_CAR_LANDINGS.length && related.length < limit; step += 1) {
    related.push(HOUSTON_CAR_LANDINGS[(idx + step) % HOUSTON_CAR_LANDINGS.length]);
  }
  return related;
}
